
import clientAuth from "../clientAuth"
export default {
    index: () => clientAuth.get(`kilometer/index`),
    update: (id, userData) => clientAuth.post(`kilometer/update/${id}`, { json: userData }),
    destroy: (id) => clientAuth.delete(`kilometer/destroy/${id}`),
    store: (userData) => clientAuth.post(`kilometer/store`, { json: userData }),
    show: (id) => clientAuth.get(`kilometer/show/${id}`),


};